import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import { LitterCardInterface } from '../../../structures/models/litter';
import { LITTER_DEFAULT_IMAGE } from '../../../utils/constants';
import DateHelper from '../../../utils/DateHelper';
import { setFallbackImage } from '../../../utils/imageHelper';
import { cloudinaryTransform } from '../../../utils/cloudinaryTransformations';

interface LitterCardProps {
  litter: LitterCardInterface;
}

const LitterCard: React.FC<LitterCardProps> = (data): ReactElement => {
  const { litter } = data;

  return (
    <>
      <div key={litter.id} className="litter-card bg-blue-200 border rounded">
        <a href={litter.route}>
          <div className="position-relative">
            <img
              onError={(e) => {
                setFallbackImage(e, LITTER_DEFAULT_IMAGE);
              }}
              className="card-img-top rounded"
              src={litter.thumbnailUrl
                ? cloudinaryTransform(
                  litter.thumbnailUrl,
                  [
                    't_lpr-full-transform',
                    'c_thumb,h_300,w_300',
                  ],
                ) : LITTER_DEFAULT_IMAGE}
              alt={litter.seller.businessName}
            />
          </div>
          <div className="litter-info-container">
            <div className="top-container d-flex justify-content-between">
              <div className="top-left-container d-flex justify-content-left">
                <p className="mb-0">
                  <strong>
                    {litter.seller.businessName}
                  </strong>
                </p>
              </div>

            </div>
            <div className="d-flex justify-content-between">
              <span className="litter-lem">
                <strong>
                  {litter.count}
                  {` ${litter.count === 1 ? 'Puppy' : 'Puppies'}`}
                </strong>
              </span>
              <span className="badge badge-lg badge-l-gray my-auto badge-pill">
                {DateHelper.getHumanReadableAge(litter.birth_date)}
              </span>
            </div>
            <div className="d-flex justify-content-end">
              {litter.city != null && (
                <span className="badge badge-lg badge-l-gray my-auto badge-pill">
                  <strong>
                    {litter.city}
                    {', '}
                    {litter.state}
                  </strong>
                </span>
              )}
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

if (document.getElementsByClassName('react-litter-card').length > 0) {
  document.querySelectorAll('.react-litter-card').forEach((element) => {
    const litter = JSON.parse(element.getAttribute('data-litter') ?? '');
    ReactDOM.render(<LitterCard litter={litter} />, element);
  });
}

export default LitterCard;
